export const imageUrl = (img?: string, variant?: string, extension?: string) => {
    if (!img)
        return img;
    if(img.indexOf("http") === 0)
        return img

    const pathArray = (img || "").split("/")
    let fileName = pathArray.pop()
    const path = pathArray.join("/")
    if(extension) {
        let splitName = (fileName || "").split(".")
        if(splitName.length > 1)
            splitName[splitName.length -1] = extension
        else
            splitName.push(extension)
        fileName = splitName.join(".")
    }
    if(process.env.REACT_APP_PRIVATE_IMAGE_URL && path.startsWith("private/"))
        return `${process.env.REACT_APP_PRIVATE_IMAGE_URL}?path=${encodeURIComponent([path, (variant !== undefined ? variant : "s_") + fileName].filter(i => i).join("/") )}`
    
    return [process.env.REACT_APP_IMAGE_URL, path, (variant !== undefined ? variant : "s_") + fileName].filter(i => i).join("/")
}
